export default {
  domainDirectory: {
    title: "Official Domains",
    subtitle: "Verify official entry points here. Tap a domain to copy it.",
    available: "currently reachable",
    loading: "Loading domains…",
    loadFailed: "Could not load domains",
    retry: "Reload",
    empty: "No active domains",
    tapToCopy: "Tap to copy",
    checking: "Checking",
    checkingShort: "Checking",
    online: "Reachable",
    offline: "Connection timed out",
    waiting: "Waiting for test",
    timeout: "Timed out",
    testAll: "Test all domains now",
    updatedEveryFifteenSeconds: "Connections are tested automatically every 15 seconds",
    saveReminder: "Take a screenshot of this page to keep the domain details",
    copied: "Domain copied",
    names: {
      primary: "Primary Domain",
      chinaAccel: "China Acceleration",
      secondary: "Secondary Domain",
    },
  },
  nickname: {"edit": "Edit nickname", "hint": "2–20 Chinese/English letters, digits or _", "saved": "Nickname saved", "taken": "This nickname is already in use", "invalid": "Use 2–20 Chinese/English letters, digits or _. Reserved names are not allowed.", "failed": "Could not save. Please retry."},
  common: {
    confirm: "Confirm",
    cancel: "Cancel",
    search: "Search",
    language: "Language",
    pleaseRelogin: "Session expired, please sign in again",
    developing: "Feature under development",
    switched: "Switched",
    currentLanguage: "Current Language",
    selectLanguage: "Select Language",
    loading: "Loading...",
    loadingMore: "Loading more...",
    noMoreData: "No more data",
    noData: "No data",
    serverUnavailable: "Server temporarily unavailable",
    loadFailed: "Load failed",
    requestFailed: "Request failed",
    retry: "Tap to retry",
    projectName: "PANTA MARKET",
    duplicateSubmission: "Please do not submit repeatedly",
    fee: "Fee",
    submit: "Submit",
    tip: "Notice",
    connecting: "Connecting...",
    connectWalletFirst: "Please connect your wallet first",
    connect: "Connect",
    insufficientBalance: "Insufficient balance",
    copyFailed: "Copy failed",
    sessionAuthRelogin: "Sign in again",
    sessionAuthStay: "Stay",
    pager: {
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
    },
  },
  tabbar: {
    home: "Home",
    market: "Timeline",
    timeline: "Timeline",
    prediction: "AI Event Contract Prediction",
    createMarket: "Create Market",
    planet: "Finance",
    trade: "Trade",
    finance: "Finance",
    fund: "Fund",
    assets: "Assets",
    rank: "Rank",
    planethistory: "History"
  },
  tradeMenu: {
    contract: "Event Contract",
    insurance: "Insurance",
    spot: "Spot",
    flash: "Flash Swap"
  },
  home: {
    searchPlaceholder: "BTC",
    categoryAll: "All",
    categoryCrypto: "Crypto",
    categoryCommodity: "Commodities",
    categoryEquity: "Equities",
    categoryForex: "Forex",
    categoryMetal: "Metals",
    predictionLabel: "Prediction",
    rise: "Up",
    fall: "Down",
    viewMoreOptions: "View {n} more options",
    yes: "Yes",
    no: "No",
    catCrypto: "Crypto",
    catTech: "Tech",
    catMetal: "Metals",
    catSports: "Sports",
    catPolitics: "Politics",
    catEntertainment: "Fun",
    statusHot: "Hot",
    statusLive: "Live",
    statusLocked: "Locked",
    statusLockedWait: "Locked, awaiting settlement",
    comingSoon: "Coming soon",
    jouleUnit: "JOULE",
    nowLabel: "Now",
    vs: "VS",
    endAtFallback: "--",
    statusHotEn: "HOT",
    hotBannerTitle: "Event Contracts",
    homeBanner: {
      s1t1: "AI-powered",
      s1t2: "AstralX core ecosystem",
      s1cta: "AstralX",
      s2t: "Galaxy Fund",
      s2s1: "Learn about principal protection",
      s2s2: "and payout rules",
      s2cta: "Subscribe",
      s3s: "Price prediction",
      s3cta: "Predict",
    },
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "AI Prediction · Event Contracts · Smart Analysis",
    predictionCategories: {
      hot: "Timeline",
      sports: "Sports",
      world: "World",
      politics: "Politics",
      economy: "Economy"
    },
    predictionSubCategories: {
      crypto: "Spot",
      forex: "Forex",
      commodities: "Commodities"
    },
    features: {
      recharge: "Recharge",
      rechargeDesc: "Quick deposit",
      contract: "Event Contract",
      contractDesc: "Innovative financial tools",
      predict: "AI Prediction",
      fund: "PANTA MARKET Treasury",
      invite: "Invite Friends",
      global: "Global Nodes"
    },
    insurance: {
      title: "Contract Insurance Pool (JOULE)",
      poolTitle: "Contract Insurance Pool",
      aiPoolTitle: "AI Insurance Pool",
      ordinaryPoolTitle: "Event Insurance Pool",
      approxUsdt: "≈ ${amount}",
      approxUsdtRef: "≈ ${amount}",
      approxPantaRef: "≈ {amount} PANTA",
      more: "Learn More",
      yesterday: "Added Yesterday",
      service: "Smart Service"
    },
    market: {
      tabs: {
        main: "Main",
        hot: "Hot",
        rise: "Gainers",
        price: "Price"
      },
      headers: {
        pair: "Pair",
        latest: "Latest Price",
        change: "24h Change"
      },
      viewMore: "View More",
      collapse: "Collapse"
    },
    announcement: {
      title: "Announcement",
      heading: "Announcement",
      text: "Welcome to PANTA MARKET. Explore event contracts, AI market insights, and risk protection tools to read markets faster and trade predictions with more confidence.",
      time: "2026/03/01 10:00",
      gotIt: "Got it",
      viewDetail: "View details",
      systemLabel: "System announcement"
    },
    timePeriods: {
      "1min": "1 Minute",
      "30min": "30 Minutes",
      "1hour": "1 Hour"
    },
    timeframes: {
      "1s": "1 Min",
      "1m": "1 Min",
      "5m": "5 Min",
      "15m": "15 Min",
      "1h": "1 Hour",
      "4h": "4 Hours",
      "1d": "1 Day"
    },
    footer: {
      australia: "· Australia",
      uae: "· United Arab Emirates",
      attention: "· ATTENTION:",
      attentionText: "PANTA MARKET is operated by the platform itself. We do not authorize any third party to collect fees in our name. For inquiries, please contact official customer service at: {email}"
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    show: "Show",
    hide: "Hide",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    deadlineShort: "{m}/{d}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    creating: "Creating",
    createSuccess: "Created",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}",
    categories: {
      crypto: "Crypto",
      sports: "Sports",
      politics: "Politics",
      entertainment: "Fun",
      tech: "Tech"
    },
    subCategories: {
      general: "General",
      spot: "Spot",
      contract: "Contract",
      macro: "Macro"
    }
  },
  marketDetail: {
    tabTrades: "Recent Trades",
    tabLp: "LP",
    tabPositions: "Positions",
    tabRules: "Rules",
    colAddress: "Address",
    colTime: "Time",
    colType: "Type",
    colVolumePrice: "Size / Price",
    colTurnover: "Notional",
    typeBuy: "Buy",
    typeSell: "Sell",
    empty: "No data",
    share: "Share",
    rulesBody: "This is a binary event market. The book may lock before settlement. After the outcome is published, positions settle by share. Trade within your risk tolerance.",
    priceJoule: "Price (JOULE)",
    investJoule: "Size (JOULE)",
    totalLiquidity: "Liquidity",
    dealPrice: "Fill price",
    estProfit: "Est. profit",
    jouleBalance: "JOULE balance: {n}",
    positionCount: "Position: {n}",
    max: "Max",
    confirmOrder: "Confirm",
    ordering: "Submitting...",
    enterAmount: "Enter an amount",
    invalidPrice: "Enter a valid price",
    amountExceed: "Amount exceeds balance",
    orderSuccess: "Order placed",
    poolSize: "Pool size",
    colBalance: "Balance",
    shares: "{n} shares",
    rulesTitle: "Rules",
    rulesValue: "No description yet",
    settleSource: "Settlement source",
    settleValue: "No description yet"
  },
  mockData: {
    tx: {
      deposit: "Deposit",
      withdraw: "Withdraw",
      depositReceived: "Deposit credited",
      teamReward: "Team reward",
      accelerationGrant: "Acceleration quota granted",
      insurancePayout: "Insurance payout"
    },
    finance: {
      steady7d: "Steady Finance · 7 Days",
      aggressive30d: "Growth Finance · 30 Days"
    },
    notice: {
      welcomeTitle: "Welcome to PANTA MARKET",
      welcomeContent: "Explore event contracts, AI market insights, and risk tools to read markets faster and trade with more confidence.",
      welcomeShort: "Welcome to PANTA MARKET.",
      eventContractTitle: "About event contracts",
      eventContractContent: "Connect your wallet to try trading. Market data comes from public APIs—please manage your risk.",
      detailTitle: "Message detail",
      detailContent: "For more announcements and product notes, check Messages and the official community.",
      categorySystem: "System",
      categoryAnnouncement: "Announcement"
    },
    legal: {
      terms: "PANTA MARKET Terms of Service\n\nBy using PANTA MARKET (“the Platform”), you agree to these terms.\n\n1. Services\nThe Platform provides AI prediction, event contracts, and wallet-linked accounts. Some market data comes from public APIs. Predictions are for reference only and are not investment advice.\n\n2. Wallet & Account\nYou are solely responsible for your private keys and seed phrase. Losses from key leakage, device loss, or user error are your responsibility.\n\n3. Risk Notice\nDigital assets and prediction markets are high risk and may result in loss of principal. Participate only within your risk tolerance.\n\n4. Prohibited Use\nYou may not use the Platform for money laundering, fraud, market manipulation, or other illegal activity. We may restrict or terminate access if violations are found.\n\n5. Disclaimer\nTo the fullest extent permitted by law, the Platform is not liable for losses caused by network outages, third-party failures, or extreme market conditions.\n\n6. Changes\nWe may update these terms. Continued use after updates means you accept the revised terms.\n\nFor questions, contact official support.",
      privacy: "PANTA MARKET Privacy Policy\n\nWe value your privacy. This policy explains what we collect and how we use it.\n\n1. Information We Collect\n· Wallet address and necessary on-chain interaction data\n· Device and log data for security, troubleshooting, and product improvement\n· Materials you voluntarily submit for support or appeals\n\n2. How We Use Information\nTo identify accounts, process trades and settlement, manage risk and compliance, improve products, and provide support.\n\n3. Sharing\nWe do not sell personal information. We may share data only when required by law, to protect users and the Platform, or with service partners you authorize.\n\n4. Security\nWe apply reasonable technical and organizational safeguards. Internet transmission is never perfectly secure—please protect your own devices and keys.\n\n5. Your Choices\nYou may stop using the service and disconnect your wallet. Public on-chain data cannot be unilaterally erased by the Platform.\n\n6. Updates\nWe may update this policy and will notify you of material changes in-product where appropriate.\n\nFor privacy questions, contact official support."
    }
  },
  sports: {
    upcoming: "Upcoming",
    gameView: "Game view",
    empty: "No matches",
    draw: "Draw",
    viewMore: "View more"
  },
  wealthAccess: {
    exchangeThresholdFailed: "Exchange failed: requirements not met",
    internalPrice: "Internal price",
    marketPrice: "Market price",
    coinBasis: "Coin-based",
    legacyBasis: "Coin-based",
    contractBasis: "Settlement basis",
    unitPrice: "Purchase unit price",
    quotaUsed: "Lifetime internal purchases",
    quotaRemaining: "Internal-price quota remaining",
    quotaHint: "{limit} PANTA lifetime total across all plans. Disabling internal prices, maturity or VIP changes never reset this total.",
    principal: "Principal",
    principalReturn: "Principal returned at maturity",
    dailyYield: "Daily gross yield",
    coinYieldHint: "Daily gross yield = PANTA principal × annual rate ÷ 360, rounded down in atomic units. Price changes do not change contract coins. Distribution follows the applicable rules.",
    legacyHint: "Coin-based contract. PANTA principal repayment is converted at the contractual maturity price.",
    quotaError: "Internal-price quota exceeded. Reduce the quantity; orders are not split or switched to market price automatically.",
    permissionChanged: "This plan is no longer available for your VIP. The list has been refreshed.",
    quoteChanged: "Price or eligibility changed. Review the new quote and confirm again.",
    quoteExpired: "Quote expired. Refresh and review before confirming.",
    retryQuote: "Refresh quote",
    stakeGateTitle: "PANTA sell staking requirement",
    stakeGateBody: "VIP{vip}: active stake {staked} PANTA; required {required} PANTA; shortfall {shortfall} PANTA. Selling only is restricted; buying is unaffected.",
    goStake: "Go to staking",
    refreshEligibility: "Refresh eligibility",
  },
  fundPage: {
    heroTitle: "PANTA rewards distributed daily",
    heroDesc: "Subscribe to the Galaxy fund for annualized dividends",
    learnMore: "Learn more",
    allProducts: "All products",
    subscribe: "Subscribe",
    stake: "Stake",
    stakePreview: "Stake preview",
    searchCoin: "Search coin",
    allPeriods: "All periods",
    colCoin: "Fund Name",
    colApy: "Token APY",
    colTerm: "Term",
    fixedTerm: "Fixed",
    galaxyProduct: "Galaxy {n}",
    termLabel: "Term",
    apyLabel: "APY",
    stakeCap: "Personal holdings",
    stakeAmount: "Stake amount",
    tradingJouleBalance: "Trading account balance",
    estEarnings: "Est. earnings",
    stakeDisclaimer: "Yield is illustrative, not guaranteed. About 70% goes to available balance and 30% to trial funds; trial funds unlock after ~3x turnover.",
    stakeSuccess: "Stake successful",
    annualized: "Est. APY",
    perShareYield: "Yield / 10k (WBS)",
    dayUnit: "d",
    empty: "No fund products yet",
    loadFailed: "Failed to load",
    rulesTitle: "Fund info",
    gotIt: "Got it",
    pantaAvailable: "PANTA available",
    activeFaceValue: "Active shares",
    totalReward: "Fund earnings (PANTA)",
    fundYieldUnavailable: "--/Update required",
    effectiveVip: "Effective VIP",
    myHoldings: "Fund Purchase History",
    faceValue: "Value",
    maturity: "Maturity",
    stakeStart: "Staked at",
    pantaPrice: "PANTA price",
    noMoreHoldings: "No more holdings",
    subscriptionStatus: {
      ACTIVE: "Active",
      SETTLED: "Settled",
      CANCELLED: "Cancelled",
      MANUAL_REVIEW: "Manual review",
    },
    minPanta: "Min PANTA",
    pantaAmount: "PANTA amount",
    stepHint: "Multiple of {step}, min {min}",
    getQuote: "Get quote",
    confirmStake: "Confirm stake",
    jouleDebit: "JOULE debit",
    expectedPanta: "Staked PANTA",
    quoteExpires: "Quote expires",
    unavailable: "Not available",
    invalidAmount: "Enter a valid PANTA step amount",
    quoteFailed: "Quote failed",
    rewards: "Fund rewards",
    unlock: "PANTA unlock batches",
    unlockProgress: "Consumed volume",
    pantaLedger: "PANTA ledger"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    comingSoon: "Coming soon",
    tagPolitics: "Politics",
    tagEsports: "Esports",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    }
  },
  withdrawSheet: {
    title: "Withdraw",
    balance: "Balance",
    processing: "JOULE withdrawal in progress...",
    success: "JOULE withdrawal successful!",
    withdrawing: "Withdrawing...",
    withdrawSuccess: "Withdrawal accepted. Check records for progress.",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Minimum {min} USDT. Final fee follows the create response.",
    available: "Available {token}",
    amountLabel: "Withdraw Amount",
    amountPlaceholder: "Enter amount (min {min} USDT)",
    vault: "Vault contract",
    feeHint: "Estimated fee is for display only; final fee/net come from the create response",
  },
  depositSheet: {
    broadcastPending: "Transaction broadcast. Syncing deposit status; do not transfer again.",
    broadcastSavedWarning: "Transaction broadcast, but local storage failed. Keep this hash and contact support:",
    creditSummary: "Deposited {input} USDT → Converted to {output} {asset}",
    autoExchange: "Deposited USDT is automatically converted to Joule at the rate when credited, with no conversion fee.",
    title: "Deposit JOULE",
    depositTo: "Deposit To",
    spotAccount: "Spot Account",
    network: "Network",
    networkWarning: "Only BSC/BEP20 network deposits are supported. Asset losses caused by using other networks cannot be recovered.",
    depositAddress: "Receiver Address",
    address: "Address",
    depositTAKER: "Deposit JOULE",
    generating: "Generating...",
    generateSuccess: "Generated successfully",
    generateFailed: "Generation failed",
    saveAndShare: "Save & Share Address",
    more: "More",
    save: "Save",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Transfer configured USDT from your logged-in wallet to the receiver address",
    wallet: "Wallet",
    max: "Max",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "Saved Image",
    download: "Download",
    pleaseGenerate: "Please generate image first",
    downloadSuccess: "Download successful",
    saveSuccess: "Save successful",
    saveFailed: "Save failed",
    needPermission: "Permission needed to save image to album",
    recharge: "Recharge",
    pleaseUseDapp: "Please use wallet to open dapp operation",
    rechargeAddress: "Recharge Address",
    copy: "Copy",
    copySuccess: "Copied successfully",
    loadingAddress: "Loading recharge address...",
    loadAddressFailed: "Failed to get recharge address",
    clickToRetry: "Click to retry",
    loading: "Loading...",
    loadFailed: "Failed to get deposit address",
    claimButton: "Claim Deposit",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim (accepted ≠ credited)",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x + 64 hex tx hash",
    environment: "Environment",
    envMainnet: "Mainnet",
    envTestnet: "Testnet",
    confirmations: "Required confirmations",
    tokenContract: "USDT contract",
    stepsTitle: "Deposit steps",
    step1: "Confirm network and receiver; send only the configured USDT to this address",
    step2: "Complete the on-chain transfer in your wallet",
    step3: "Paste the tx hash to claim, then track progress in deposit records",
    optionalAmount: "Amount (optional note)"
  },
  fundRecords: {
    depositTitle: "Deposit Records",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    feeLabel: "Fee: {fee}",
    detailTitle: "Record Detail",
    statusLabel: "Status",
    amountLabel: "Amount",
    ledgerTitle: "Ledger entries",
    ledgerEmpty: "No linked ledger entries",
    claimHint: "Claim record; amount comes from linked transfers",
    confirmProgress: "Confirmations {cur}/{req}",
    depositStatus: {
      PENDING_CHAIN: "Waiting for on-chain tx",
      PENDING: "Pending",
      UNMATCHED: "No matching transfer",
      CONFIRMING: "Detected, awaiting confirmations",
      CONFIRMED: "Verified on-chain, awaiting credit",
      CREDITED: "Credited",
      REJECTED: "Verification failed",
      MANUAL_REVIEW: "Under manual review",
      REORGED: "Reorg, pending review",
      VERIFIED: "Verified",
    },
    withdrawStatus: {
      PENDING_REVIEW: "Pending review",
      AUTHORIZED: "Authorized, awaiting on-chain",
      BROADCASTING: "Broadcasted, awaiting confirmation",
      CONFIRMED: "Withdrawal completed",
      REJECTED: "Rejected, funds unfrozen",
      EXPIRED: "Authorization expired",
      MANUAL_REVIEW: "On-chain anomaly, manual review",
    },
  },
  withdraw: {
    title: "Withdraw",
    headerTitle: "Withdraw",
    address: "Withdrawal Address",
    addressLabel: "Withdrawal Address",
    addressPlaceholder: "Enter or paste address",
    addressHint: "Withdrawal will be sent to your wallet address",
    network: "Network",
    selectNetwork: "Select Network",
    networkHint: "Please ensure the withdrawal address matches the selected network",
    withdrawAmount: "Withdraw Amount",
    receiveAmount: "Actual Arrival",
    networkFee: "Network Fee",
    submit: "Confirm Withdrawal",
    submitButton: "Withdraw",
    balance: "Balance",
    all: "All",
    amountPlaceholder: "Please enter",
    minimumWithdrawal: "Minimum withdrawal amount: {amount} USDT",
    minimumWithdrawalTAKER: "Minimum withdrawal amount: {amount}TAKER",
    fee: "Fee",
    confirm: "Confirm",
    confirmTitle: "Confirm Action",
    confirmContent: "Are you sure you want to proceed?",
    toasts: {
      fetchFailed: "Failed to fetch assets",
      enterAddress: "Please enter a withdrawal address",
      enterValidAmount: "Please enter a valid withdrawal amount",
      insufficientBalance: "Insufficient balance",
      minimumAmount: "Minimum withdrawal amount is {amount} USDT",
      processing: "Processing...",
      success: "Withdrawal successful!",
      requestSuccess: "Withdrawal request successful",
      requestFailed: "Withdrawal failed, please try again",
      notConfigured: "Withdrawals are not available yet. Please try again later."
    }
  },
  appeal: {
    title: "Asset Audit Assistance",
    records: "Submission Records",
    recordsTitle: "Submission Records",
    noRecords: "No submission records",
    submitTime: "Submit Time",
    statusPending: "Pending",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    failedReason: "Rejection Reason",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "Loading...",
    walletAddress: "Address Bound to PANTA MARKET",
    address: "Address",
    walletAddressPlaceholder: "Enter PANTA MARKET login address",
    autoFill: "Auto Fill",
    depositAmount: "Deposit Amount",
    depositAmountPlaceholder: "Enter deposit amount",
    tokenType: "Token Type",
    selectToken: "Select token",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "Transfer Time",
    selectTime: "Select transfer time",
    timeRangeHint: "Relevant data generated between March 5, 2026 00:00 and March 11, 10:00 (SGT).",
    txHash: "HASH / TXID",
    txHashPlaceholder: "Enter transaction hash",
    txHashHint: "Can be queried on blockchain explorer",
    uploadImages: "Transfer Record Screenshot",
    uploadHint: "Optional, upload up to 9 images",
    addImage: "Add Image",
    submit: "Submit",
    submitting: "Submitting...",
    submitSuccess: "Submitted successfully",
    submitFailed: "Submission failed, please try again",
    uploadingImages: "Uploading images...",
    uploadImagesFailed: "Failed to upload images",
    warningTitle: "Important Notice",
    warningText: "If the submitted record is verified successfully, you will be rewarded with 5% of the subscription power. If false information is provided, the account will be frozen."
  },
  deposit: {
    headerTitle: "Deposit USDT",
    qrTitle: "Deposit USDT",
    addressLabel: "Deposit To",
    addressCopied: "Address copied successfully",
    connectPrompt: "Please connect first",
    usdtBalance: "USDT Balance",
    amaBalance: "JOULE Balance",
    amount: "Amount",
    amountPlaceholder: "Enter {token} amount",
    minimumNotice: "Min {min} {token}",
    confirm: "Submit",
    processing: "Processing...",
    helpText: "Deposit instructions: Please ensure your wallet has sufficient balance",
    depositNotice:
      "Send configured USDT to the receiver, then claim. 202 only means accepted; only CREDITED means credited.",
    toasts: {
      invalidAmount: "Amount cannot be less than {min} {token}",
      insufficientFunds: "Insufficient balance",
      checkingAllowance: "Checking allowance...",
      approving: "Approving...",
      approveSuccess: "Approval successful",
      depositing: "Depositing...",
      depositSuccess: "Deposit successful",
      depositFailed: "Deposit failed",
      balanceLoadFailed: "Could not read wallet test USDT balance. Refresh and try again",
      userCancelled: "You cancelled the operation",
      wrongNetwork: "Please switch to the correct network",
      contractError: "Contract execution failed",
      gettingPaymentInfo: "Getting payment info...",
      cannotGetBalance: "Cannot get balance, please refresh and try again",
      enterValidAmount: "Please enter a valid amount",
      claimPending: "Deposit accepted. Check records for credit progress.",
      invalidTxHash: "Enter a valid tx hash (0x + 64 hex chars)",
      configNotReady: "Deposits are not available yet. Please try again later."
    }
  },
  team: {
    headerTitle: "My Team",
    contractEarnings: "Trading",
    btcFund: "Finance",
    stats: {
      personalEarnings: "Personal Earnings",
      teamEarnings: "Team Earnings",
      personalVolume: "Personal Vol.",
      teamVolume: "Team Vol.",
      personalPower: "Personal Power",
      teamTotalPower: "Team Power",
      periodPersonal: "Personal Volume",
      periodTeam: "Team Earnings",
      totalTeam: "Team Volume",
      personalSubscribed: "Personal Staked",
      teamSubscribed: "Team Staked"
    },
    unclassifiedHint: "Unclassified payouts pending review: {amount} {asset}",
    links: {
      invite: "Invite Friends",
      details: "Team Details"
    },
    inviteBannerTitle: "Invite Friends to Unlock Team Commissions",
    inviteBannerSubtitle: "Unlock your team commissions",
    inviteBannerCta: "Join Now"
  },
  teamDetails: {
    myReferrals: "My Referrals",
    currentLevel: "Current level: {level}",
    effectiveLevel: "Effective level: {level}",
    nextLevel: "Next level",
    nextLevelClosed: "Not open yet",
    totalMembers: "Direct referrals",
    activatedCount: "Activated",
    validMembers: "Valid Members",
    teamLevel: "Team Level: {level}",
    tradeTeam: "Trading Team",
    financeTeam: "Fund Team",
    predictTeam: "Predict Team",
    teamMembers: "Team Members",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings",
    teamFlowJoule: "Team Volume",
    teamPowerUsdt: "Team Volume",
    teamTotalCount: "Team Size",
    teamEarningsWithUnit: "Team Earnings ({unit})",
    teamVolumeWithUnit: "Team Volume ({unit})",
    teamActiveStakeWithUnit: "Team Active Stake ({unit})",
    effectiveTradingCount: "Active Traders",
    activeInvestorCount: "Active Investors",
    dividendEligibleCount: "Dividend Eligible",
    myTeamReward: "Team Earnings",
    teamPerformance: "Team Volume",
    directMembers: "Team Members",
    filterAll: "All",
    filterEffective: "Effective",
    filterDividend: "Dividend",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    addRemark: "Add note",
    editRemark: "Edit note",
    saveRemark: "Update",
    remarkPlaceholder: "Enter a note",
    remarkSaved: "Note saved",
    remarkFailed: "Failed to save note",
    myCurrentLevel: "Current level: {level}",
    personalTradePerf: "Personal trading volume: {value}",
    personalStakePerf: "Personal staking volume: {value}",
    currentTotalPerf: "Self upgrade: {value}",
    currentAreaPerf: "Team upgrade: {value}",
    viewingIndirect: "{name}'s directs",
    includesAllLevels: "Includes all levels",
    inviteDetails: "Invite details",
    startDate: "Start date",
    endDate: "End date",
    dateTo: "to",
    status: "Status: ",
    statusActivated: "Activated",
    statusNotActivated: "Not activated",
    statusDividendActivated: "Dividend eligible",
    statusDividendNotActivated: "Dividend not eligible",
    statusValid: "Activated",
    statusInvalid: "Not activated",
    time: "Bound at",
    bindTime: "Bound at",
    level: "Level",
    tradeLevel: "Trading level",
    fundLevel: "Fund level",
    inviteType: "Invite type",
    viewTeam: "Team details",
    viewDetail: "View details",
    noSubMembers: "No direct referrals yet",
    directCount: "Direct referrals",
    teamSize: "Team size",
    teamTotalPerf: "Team volume",
    teamTotalStake: "Team active stake",
    personalTotalPerf: "Personal volume",
    personalTotalStake: "Personal active stake",
    settledOrderCount: "Settled orders",
    activeSubscriptionCount: "Active subscriptions",
    eventContractParticipants: "Settled orders",
    communityValidCount: "Dividend eligible: ",
    communityTotalPerf: "Self volume: ",
    areaTotalPerf: "Active stake: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    peopleUnit: "{n}",
    loadFailed: "Load failed, please retry",
    forbidden: "No permission to view this team"
  },
  teamMemberModal: {
    totalProfit: "Total Profit",
    totalFlow: "Total Flow",
    totalInvites: "Total Invites",
    validMembers: "Total Valid Members"
  },
  my: {
    headerTitle: "My",
    login: "Tap to Login",
    inviteCode: "Invite Code:",
    groups: {
      common: "Common Features",
      trading: "Trading",
      finance: "Finance",
      help: "Help"
    },
    features: {
      invite: "Invite Friends",
      team: "My Team",
      insurance: "Event Contract Insurance",
      contract: "Event Contract",
      exchange: "Exchange",
      fund: "AI Treasury Fund",
      communitySquare: "Community Square",
      createEvent: "Create Event",
      community: "Official Community",
      terms: "Terms of Service",
      announcement: "Announcements",
      privacy: "Privacy Policy",
      aboutUs: "About Us"
    }
  },
  sidebar: {
    loginAccount: "Login Account",
    inviteBanner: "Invite Friends & Earn Team Commissions",
    inviteCode: "Invite Code",
    defaultName: "PANTA MARKET",
    logoutWallet: "Disconnect Wallet"
  },
  community: {
    title: "Official Community",
    bannerTitle1: "Join Our Community",
    bannerTitle2: "Connect with Global Users",
    linkCopied: "Link Copied"
  },
  supportPage: {
    title: "Contact Support",
    hello: "PANTA MARKET Support",
    desc: "This is a demo support page. Until live ticketing is available, reach us via email or the official community.",
    emailLabel: "Support email",
    hoursLabel: "Hours",
    hoursValue: "Daily 10:00–22:00 (SGT)",
    channelLabel: "Preferred channel",
    channelValue: "Official community / email",
    copy: "Copy",
    tip: "Never transfer funds or grant approvals to anyone claiming to be “official”. We will never ask for your private key or seed phrase.",
    goCommunity: "Open Official Community"
  },
  invite: {
    headerTitle: "Invite Friends",
    rulesEntry: "Invite Rules",
    subtitle: "Earn from every team trade",
    mainTitle: "Invite & Earn",
    description: "Share the link — friends trade, you get rewards",
    bindSuperior: "Bind superior",
    bindPlaceholder: "Enter invite code or wallet address",
    bindButton: "Bind",
    binding: "Binding…",
    boundLabel: "Superior bound",
    modalDesc: "You have not bound a superior yet. Enter an invite code or wallet address to join team rewards. Link invite info is filled automatically; otherwise a default superior is prefilled.",
    later: "Later",
    yourCode: "Your Invite Code",
    shareLink: "Share Link",
    inviteButton: "Invite Friends",
    mainTitle_old: "Invite Friends to Earn Together",
    subTitle: "Get High Commissions",
    viewRules: "View Rules",
    rulesLink: "View Referral Rules >",
    rulesTitle: "Referral Rules",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "Invite Friends",
    referralCode: "Referral Code",
    inviteLink: "Invitation Link",
    loading: "Loading...",
    copyButton: "Copy Invitation Link",
    toasts: {
      emptyContent: "Content is empty",
      copySuccess: "Copied successfully",
      bindSuccess: "Bound successfully",
      bindFailed: "Bind failed",
      alreadyBound: "Superior already bound; cannot change",
      loginFirst: "Please connect wallet first",
      invalidCode: "Please enter a valid invite code or wallet address",
      cannotBindSelf: "Cannot bind yourself",
    }
  },
  finance: {
    title: "Finance page is under development..."
  },
  finanfund: {
    title: "PANTA MARKET Treasury Fund",
    subtitle: "Simple, Efficient, Easy Earnings",
    productName: "PANTA MARKET Treasury Fund",
    minAmount: "Min Amount",
    incomeRatio: "Income Ratio",
    lockPeriod: "Lock Period",
    dailyReturn: "Daily Return",
    earning: "Earned",
    redemptionRules: "Redemption Rules",
    rules: {
      rule1: "PANTA MARKET Treasury Fund cannot be redeemed after custody",
      rule2: "Daily earnings are automatically credited",
      rule3: "Locked amount will be returned after the lock period ends"
    },
    subscription: "Subscribe",
    amountPlaceholder: "Enter amount",
    balance: "Balance",
    availableFunds: "Available Funds",
    all: "All",
    subscribeButton: "Subscribe",
    internalAssetSubscribeButton: "Internal Asset Deposit",
    toasts: {
      productIdNotExist: "Product ID does not exist",
      enterValidAmount: "Please enter a valid subscription amount",
      minAmountRequired: "Subscription amount cannot be less than {amount} USDT",
      subscribeSuccess: "Subscription successful",
      subscribeFailed: "Subscription failed",
      internalAssetSubscribeSuccess: "Internal asset deposit successful",
      internalAssetSubscribeFailed: "Internal asset deposit failed"
    }
  },
  assets: {
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    availableAssets: "Available Assets",
    noHoldings: "No holdings yet",
    mainSystemPanta: "Main System (PANTA)",
    transferToMain: "Transfer to Main System",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "Trading",
    insuranceAccountShort: "Insurance",
    copyAccountShort: "Copy",
    copyAccountJoule: "Copy account (JOULE)",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyTotalPnl: "Copy PnL",
    transferSheet: {
      title: "Transfer",
      pairCopy: "Trading / Copy Trade",
      pairInsurance: "Trading / Insurance",
      tradingAccount: "Trading Account",
      copyAccount: "Copy Trade Account",
      insuranceAccount: "Insurance Account",
      jouleHint: "JOULE transfers only",
      submit: "Submit",
      transferring: "Transferring...",
      success: "Transfer successful",
      failed: "Transfer failed, please retry",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Personal Fund Stake",
    stakedPlusRewardPanta: "Stake + Est. Earnings",
    stakedPlusRewardTipTitle: "Stake principal + estimated earnings",
    stakedPlusRewardTip:
      "This amount is staked principal plus estimated total earnings.",
    stakedPrincipalLabel: "Stake principal",
    stakedExpectedYieldLabel: "Estimated earnings",
    annualEarningsPanta: "Personal Fund Rewards Paid",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "Fund Team Rewards Pending (PANTA)",
    fundTeamPaidPanta: "Fund Team Rewards Paid (PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "Estimated Pending Airdrop",
    cumulativeAirdropValue: "Cumulative airdrop value: {value} USDT",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    deductedNodeCount: "Deducted Nodes",
    invalidNodeCount: "Invalid Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Node purchase grants quota only; price follows quote",
    buyNode: "Buy Node",
    buyNodeModal: {
      title: "Buy Trading Node",
      description: "Pay {amount}JOULE to get trading node access",
      quotePreview: "{name} · {amount} JOULE · remaining {remaining}",
      afterBalance: "Balance after purchase ≈ {amount} JOULE",
      pickProduct: "Select node product",
      availableBalance: "Available Balance",
      cancel: "Cancel Purchase",
      confirm: "Confirm Purchase",
      purchasing: "Purchasing...",
      success: "Purchase successful",
      failed: "Purchase failed, please retry",
      insufficient: "Insufficient balance, please deposit first",
      unavailable: "Not available yet"
    },
    tradingAccountRecords: "Trading Details",
    wealthAccountRecords: "Fund Details",
    insuranceAccountRecordsShort: "Insurance",
    detailTitle: "Asset Details",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    jouleAvailable: "JOULE Available",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceFrozen: "Insurance Frozen (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    totalSum: "Total",
    available: "Available",
    deposit: "Deposit",
    withdraw: "Withdraw",
    myAccountRecords: "Account",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "Bet stake",
      WIN_PAYOUT: "Trade profit",
      LOSS_SETTLEMENT: "Trade loss",
      REFUND: "Refund",
      INSURANCE_PREMIUM: "Premium expense",
      INSURANCE_PAYOUT: "Insurance payout",
      INSURANCE_TRANSFER_IN: "Insurance transfer in",
      INSURANCE_TRANSFER_OUT: "Insurance transfer out",
      NETWORK_DIFFERENTIAL: "Network differential",
      NETWORK_PEER: "Network peer",
      NETWORK_UNLOCK: "Earnings unlock",
      EVENT_INSURANCE_PAYOUT: "Compute payout",
      EVENT_INSURANCE_PEER: "Compute peer",
      TRANSFER_IN: "Transfer in",
      TRANSFER_OUT: "Transfer out",
      PREMIUM_LOCK: "Premium lock",
      PREMIUM_SETTLE: "Premium expense",
      PREMIUM_REFUND: "Premium refund",
      WEALTH_SUBSCRIPTION: "Fund subscription",
      SUBSCRIPTION_LOCK: "Stake lock",
      WEALTH_DAILY_REWARD: "Daily reward",
      WEALTH_TEAM_REWARD: "Team reward",
      MATURITY_RELEASE: "Maturity release",
      WEALTH_UNLOCK: "Earnings unlock",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record",
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "Trade P&L",
      PREMIUM: "Premium",
      INSURANCE_PAYOUT: "Insurance payout",
      TEAM_REWARD: "Team reward",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "Fund interest",
      UNLOCK: "Unlock",
      PRINCIPAL: "Stake / return",
      TRANSFER: "Internal transfer"
    },
    amountPendingReview: "Amount pending review",
    creditedSplit: "Available {available} · Frozen {frozen}",
    creditedSplitPending: "Split pending review",
    afterBalance: "After: available {available} · frozen {frozen}",
    unlockHint: "Frozen → available; not new earnings",
    transferFromInsurance: "Insurance account",
    transferFromMain: "Main account",
    all: "All",
    transfer: "Transfer",
    insuranceDeduction: "Insurance Deduction",
    insurancePayout: "Insurance Payout",
    noRecords: "No records",
    frozenOp: "Frozen {amount} {token}",
    lockedOp: "Locked {amount} {token}",
    availableChange: "Available {amount}",
    frozenChange: "Frozen {amount}",
    detail: {
      sessionId: "Session ID",
      networkReward: "Team reward detail",
      insuranceClaim: "AI claim detail",
      creditStatus: "Credit status",
      creditedPendingHint: "Credited; confirmation still pending",
      orderId: "Source order",
      source: "Source",
    },

    actions: {
      deposit: "Deposit",
      withdraw: "Withdraw",
      exchange: "Exchange",
      transfer: "Transfer"
    },
    loginPrompt: {
      text: "Please connect your wallet first",
      button: "Connect"
    },
    toasts: {
      connectFailed: "Connection failed, please try again"
    },
    jouleUsdtRate: "1 JOULE = {rate} USDT",
    pantaUsdtRate: "1 PANTA = {price} USDT",
  },

  wallet: {
    title: "My Wallet",
    address: "Wallet Address",
    addressCopied: "Address copied",
    inviteCode: "Invite Code",
    logout: "Logout",
    login: "Login",
    toasts: {
      networkSwitchCancelled: "Network switch cancelled by user",
      networkConfigNotFound: "Network configuration not found for {chainId}",
      signatureCancelled: "Signature cancelled by user",
      connectionFailed: "Failed to connect",
      accountSwitched: "Wallet account switched, please reconnect",
      connectionTimedOut: "Connection timed out, please try again",
      loginSuccess: "Login successful",
      logoutSuccess: "Logged out successfully",
      switchNetwork: "Please switch to {chainName} in your wallet before trying to deposit",
      wrongChain: "Unsupported network, please switch to {chainName}",
      switchingNetwork: "Switching network...",
      switchNetworkFailed: "Network switch failed, please manually switch to {chainName} in your wallet"
    }
  },
  market: {
    title: "Market",
    banner: {
      title: "Event Contract",
      desc: "Unlock the earning potential on-chain"
    },
    tabs: {
      main: "Mainstream",
      rise: "Top Gainers"
    },
    types: {
      crypto: "Cryptocurrency",
      stocks: "Stocks",
      forex: "Forex",
      commodities: "Commodities",
      favorites: "Favorites"
    },
    headers: {
      pair: "Pair",
      price: "Last Price",
      change: "Daily Change"
    },
    loading: "Loading...",
    loadingMore: "Loading more...",
    noMoreData: "No more data"
  },
  notice: {
    loginRequired: "Please log in to view announcements",
    empty: "No announcements yet",
    unpublished: "Unpublished",
    current: "Current",
    title: "Message Center",
    helpCenter: "Help Center",
    noticeDetail: "Notice Detail",
    defaultCategory: "Notice",
    viewDetail: "View Details",
    pdfViewer: "PDF Viewer",
    videoPlayer: "Video Player",
    imageViewer: "Image Viewer",
    documentViewer: "Document Viewer",
    clickToViewPdf: "Click to view PDF",
    clickToViewDocument: "Click to view document",
    openInBrowser: "Open in Browser",
    tryingViewer: "Trying viewer {current}/{total}",
    pdfLoadFailed: "PDF preview failed, please download to view",
    downloadPdf: "Download PDF"
  },
  trade: {
    title: "Event Contract",
    nextRound: "Next Round",
    posCurrent: "Current",
    aiThenPrefix: "AI then: ",
    aiUnlinked: "No linked AI",
    aiNotRecorded: "Not recorded",
    insuranceLabel: "Insurance",
    amountLabel: "Amount",
    insuranceNotSelected: 'Not selected',
    insuranceInactive: "Not in effect",
    insuranceTypeNone: "Not in effect",
    insuranceTypeEvent: "Event insurance on",
    insuranceTypeEventShort: "Event insurance",
    insuranceTypeAi: "AI insurance on",
    insuranceTypeAiShort: "AI insurance",
    insuranceTypeConverted: "Converted to event insurance",
    insuranceTypeUnknown: "Insurance status pending",
    inProgress: "In Progress",
    estimatedPnl: "Estimated P&L",
    settlementConfirming: "Confirming result",
    balanceSyncing: "Syncing balance",
    pendingReview: "Pending review",
    openPriceLabel: "Open",
    secondsUnit: "s",
    connecting: "Connecting...",
    connectWallet: "Connect",
    platformLadder: {
      title: "Platform reference quotes",
      current: "Mid",
      ask: "Ask{n}",
      bid: "Bid{n}",
      disclaimer: "Prices are platform-processed; quantities reference the exchange. Not executable orders.",
      unavailable: "Reference quotes unavailable",
    },
    actions: {
      rise: "Buy Up",
      fall: "Buy Down",
      buy: "Buy",
      sell: "Sell"
    },
    orderSuccess: "Order placed successfully!",
    orderFailed: "Order failed",
    orderConfirming: "Confirming order result, please do not submit again",
    orderNotFilled: "Order was not filled; no funds were deducted",
    unsettledIntervalConflict: "An open order already occupies this symbol and interval; wait or pick another interval",
    invalidInterval: "Invalid interval; please select again",
    chartPlatform1mOnly: "Chart for this pair only supports platform 1-minute data",
    orderDetail: {
      title: "Order details",
      orderId: "Order ID",
      symbol: "Symbol",
      interval: "Interval",
      direction: "Direction",
      aiDirection: "AI then",
      openTime: "Opened at",
      settleTime: "Expires at",
      settledAt: "Settled at",
      openPrice: "Open price",
      closePrice: "Close price",
      stake: "Stake",
      premium: "Premium",
      netProfit: "Net PnL",
      status: "Status",
      orderSource: "Order source",
      converted: "Insurance conversion",
      notRecorded: "Not recorded",
      copied: "Order ID copied",
    },
    orderStatus: {
      CREATED: "Created",
      ACCEPTED: "Accepted",
      CLOSED: "Closed",
      FUNDS_LOCKED: "Funds locked",
      AWAITING_SETTLEMENT: "Awaiting settlement",
      PROCESSING: "Processing",
    },
    insuranceBalanceInsufficient: "Insurance wallet balance insufficient",
    mainBalanceInsufficient: "Insufficient main balance",
    insuranceBalanceRequired: "Insurance balance is insufficient; cannot enable insurance",
    insuranceRulesUnavailable: "Premium rules are not ready; cannot enable insurance",
    insuranceMainRequired: "Main balance is insufficient; cannot enable insurance",
    preferenceLoading: "Loading insurance settings",
    preferenceLoadFailed: "Failed to load insurance settings; tap to retry",
    preferenceSaveFailed: "Failed to save insurance settings; retry",
    preferenceSessionEndedSaveFailed: "Session ended, but the off setting was not saved",
    premiumEstimate: "Est. premium {premium} JOULE (5-10%)",
    premiumShortfallHint: "Insurance wallet is short {amount} JOULE",
    premiumEstimateUnavailable: "Premium cannot be estimated yet",
    premiumBoundEstimate: "Bound strategy est. premium {premium} JOULE",
    insuranceConfirmTitle: "Confirm premium",
    insuranceConfirmBody: "Preview premium {premium} JOULE. The preview is final. Confirm to submit.",
    recoverTitle: "Confirm pending event order",
    recoverContent: "An unconfirmed event-contract order was found ({symbol} {direction} {amount}). The original idempotency key will be confirmed without placing a duplicate order.",
    recoverConfirm: "Confirm order",
    recoverCancel: "Cancel",
    holdings: {
      current: "Positions",
      history: "History",
      currentCount: "Open positions {n}",
      empty: "No positions",
      historyEmpty: "No history"
    },
    position: {
      openPrice: "Open Price",
      closePrice: "Close Price",
      profitLoss: "profit / loss",
      countdown: "Settlement in",
      calculating: "Calculating...",
      settled: "Settled",
      settling: "Settling",
      syncingTime: "Syncing time",
      active: "Active",
      settledAt: "Settled:",
      refunded: "Refunded",
      won: "Won",
      lost: "Lost"
    },
    modal: {
      amountPlaceholder: "Enter amount"
    },
    pairSelector: {
      title: "Select Pair",
      searchPlaceholder: "Search coins",
      ordinary: "Event contract",
      ai: "AI prediction"
    },
    errors: {
      dataNotReady: "Loading data, please wait"
    },
    marketPause: {
      default: "Market temporarily unavailable. Please try again later.",
      lastPriceStreamWarming: "Latest price feed is warming up. Please try again shortly.",
      marketWarming: "Market is warming up. Please try again shortly.",
      recovering: "Market is recovering. Please try again shortly.",
      clockNotSynced: "Server clock not synced. Please try again shortly.",
      symbolUnavailable: "This trading pair is not available"
    },
    toasts: {
      connectSuccess: "Connected successfully",
      connectCancelled: "You have cancelled the connection",
      connectFailed: "Connection failed"
    },
  },
  exchange: {
    title: "Exchange",
    from: "From",
    to: "To",
    balance: "Balance",
    all: "All",
    placeholder: "Please enter",
    fee: "Fee",
    minAmount: "Minimum swap amount: {amount} {symbol}",
    button: "Submit",
    tradeButton: "Trade",
    paymentCurrency: "Payment Currency",
    estimatedGasFee: "Estimated Gas Fee",
    gasPaymentNote: "Will use GetGas balance to pay Gas fee",
    slippage: "Slippage",
    auto: "Auto",
    approximately: "Approx",
    minReceived: "Min Received",
    exchangeRate: "Exchange Rate",
    finalAmount: "Final Amount",
    confirm: "Confirm",
    swapSuccess: "Flash Swap Success!",
    swapping: "Swapping...",
    confirmTitle: "Confirm Action",
    confirmContent: "Are you sure you want to proceed?",
    rateHint: "{usdt} USDT = {joule} JOULE",
    rateHintPair: "{from} {fromSymbol} = {to} {toSymbol}",
    rateHintUsdtToJoule: "Net amount follows the quote",
    rateHintJouleToUsdt: "Includes exchange fee; net amount follows the quote",
    rateHintPantaFree: "No fee for now; net amount follows the quote",
    feeZero: "Fee: 0 (waived)",
    feeLabel: "Fee: {fee} {symbol}",
    grossLabel: "Gross: {amount} {symbol}",
    netLabel: "Net: {amount} {symbol}",
    pantaEffectivePrice: "PANTA effective price: {price} U",
    pantaViaUsdtHint: "Priced via USDT: {price} U/PANTA · 1 U = {joulePerUsdt} JOULE",
    quoting: "Fetching quote…",
    configFee: "Joule → USDT fee {fee}",
    configLimits: "Fee {fee} · Gross value limits {min}–{max} U",
    unlimited: "Unlimited",
    quoteFailed: "Unable to get quote, please retry",
    toasts: {
      fetchFailed: "Failed to fetch assets",
      enterValidAmount: "Please enter a valid amount",
      minAmount: "Minimum swap amount is {amount} {symbol}",
      swapSuccess: "Swap successful",
      requestFailed: "Request failed",
      insufficientBalance: "Insufficient balance, unable to swap",
      usdtRestricted: "USDT under review; exchange unavailable",
      quoteExpired: "Quote expired, please confirm again",
      amountStepInvalid: "Amount does not match the required step; please adjust"
    }
  },
  globalNode: {
    title: "Buy Trading Node"
  },
  eventInsurance: {
    title: "Event Contract Insurance",
    availableBalance: "Available Balance (USDT)",
    fundTransfer: "Fund Transfer",
    lockedBalance: "Non-transferable",
    fundHistory: "Fund History",
    type: "Type: ",
    all: "All",
    transfer: "Transfer",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)",
    fundTransferTitle: "Insurance Fund Transfer",
    currency: "Currency",
    from: "From",
    to: "To",
    availableAccount: "Available Account",
    contractAccount: "Contract Account (TAKER)",
    contractInsuranceAccount: "Contract Insurance Account",
    pleaseEnter: "Please enter",
    confirmTransfer: "Confirm Transfer",
    insufficientBalance: "Insufficient balance",
    transferSuccess: "Transfer successful",
    transferFailed: "Transfer failed",
    transferring: "Transferring...",
    noRecords: "No records",
    selectAccount: "Select Account",
    cannotTransferToSameAccount: "Cannot transfer to the same account",
    cannotTransferContractAccount: "Contract account transfer not supported",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    recentPayouts: "Recent payouts",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    rulesTab: "Overview",
    agreementTab: "Full Agreement",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "I. Event Contract Prediction Rules",
      eventOpen: {
        title: "1. Insurance on",
        points: [
          "With insurance on, premium is based on order size vs account balance: ≤10% of balance → 15% premium; above → 20%.",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      eventLimit: {
        title: "2. Order threshold",
        points: [
          "Max per order is 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. Compensation entitlement rules",
        ok: [
          "50% of compensation goes to personal airdrop quota; every 50 USD unlocks one computing node",
          "30% goes to community airdrop quota by VIP rules; every 50 USD unlocks one computing node"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      eventPool: {
        title: "4. Event insurance pool payout:",
        points: [
          "Daily 2% of event insurance pool assets in PANTA is airdropped by node weight to eligible users",
          "When daily pool airdrops reach 50 USD in PANTA, one computing node is reduced"
        ]
      },
      eventProfit: {
        title: "5. P&L rules",
        points: [
          "Correct: receive principal 100% + profit (80%)",
          "Wrong: lose all stake principal; prediction ends"
        ]
      },
      aiGroup: "II. AI Event Contract Prediction Rules",
      aiFirst: {
        title: "1. First order requires manual input"
      },
      aiOpen: {
        title: "2. Insurance on",
        points: [
          "With insurance on, pay 5%–10% of the position amount as premium",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      aiLimit: {
        title: "3. Order limits",
        points: [
          "Amounts must follow the position table, and each direction must match the AI signal",
          "If not following the table, it becomes a normal event contract prediction",
          "Eight consecutive losses unlock the stated compensation entitlement",
          "A winning order resets the sequence to step 1"
        ]
      },
      table: {
        level: "Account level",
        order1: "Order 1",
        order2: "Order 2",
        order3: "Order 3",
        order4: "Order 4",
        order5: "Order 5",
        order6: "Order 6",
        order7: "Order 7",
        order8: "Order 8"
      },
      claimOk: "Eligible for compensation",
      claimFail: "Not eligible for compensation",
      claimFailWhen: "When not eligible:",
      claimPrereq: "Compensation prerequisites:",
      aiClaim: {
        title: "4. Compensation entitlement",
        prereq: [
          "Insurance enabled",
          "Direction matches AI signal",
          "Amount/order follows the table",
          "Full settlement conditions met"
        ],
        ok: [
          "Cash compensation = cumulative loss × 90%"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      aiProfit: {
        title: "5. Profit rules",
        points: [
          "Correct: receive principal 100% + profit 80%",
          "Wrong: lose all stake principal; prediction ends or compensation applies"
        ]
      }
    },
    rulesContent: "PANTA Market Event Contract Trading Protection Plan Insurance Agreement\n\n[IMPORTANT] Before using this service, carefully read and fully understand this entire Agreement. By turning on the \"Insurance Switch\", you are deemed to have fully read, understood, and accepted this Agreement and its annexes, acknowledge that it is legally binding, and agree to comply strictly. If you disagree or do not accept it, stop using this Protection Plan immediately.\n\nArticle 1: General Provisions and Scope\n\n1.1 This Agreement explains how to participate in two PANTA Market features—\"Event Contract Prediction\" and \"AI Event Contract Prediction\"—including order formation, fees, outcome determination, fund settlement, conditional compensation, related node entitlements, and event-prediction functions. Each product has its own terms; you may not apply one product's rates, compensation conditions, or node rules to the other.\n1.2 Event Contract Prediction lets users judge a pre-listed event and its selectable outcomes and submit JOULE to create an order. Final eligible losses may generate personal or community-team node quotas under approved rules; such quotas are not instant cash compensation. AI Event Contract Prediction lets users refer to valid AI directional signals and confirm orders step by step under a selected plan's fixed amounts and sequence. When eight orders in the same eligible sequence fully settle as losses and other stated conditions are met, JOULE compensation equals 90% of the sum of eligible principal. AI signals are not outcome guarantees, and conditional compensation does not cover all outlays.\n1.3 This Agreement, versioned product parameters, specific event rules, and user confirmation pages together form the complete rules. Pages may only show approved parameters and may not use \"subject to the page\" to replace missing critical conditions. If documents conflict, stop new affected trading, explain, verify, and correct; do not unilaterally adopt an interpretation less favorable to users for existing orders after the fact.\n1.4 This project involves real assets, event prediction, conditional compensation and insurance terminology, team rewards, exchange, and fund pools. It is not a product for which risk and compliance review may be skipped. Legal characterization, licenses, service regions, user eligibility, AML, consumer protection, and data-processing requirements for each feature must be professionally verified for the actual service scope. Disclaimers do not replace required licenses, funding arrangements, or controls. This draft does not presume any particular national law and does not assert that the product is legally authorized to operate.\n\nArticle 2: Terms and Fund Status\n\n2.1 JOULE is the unit used for prediction principal, premiums, and AI compensation; PANTA is the asset unit used for node entitlement distribution and related business; USDT-equivalent is a measurement used for certain quotas and valuations. These must not be mixed. Internal numeric displays do not mean instant conversion to fiat at a fixed rate, nor that on-chain transfers are complete; this does not cancel asset rights or payment obligations already formed under law or contract.\n2.2 Order principal is the JOULE amount actually confirmed by the user and accepted by the system for an order, excluding premium. Premium is the fee calculated under the rules applicable to that order. The frozen total is usually principal plus premium; any additional fees must be disclosed separately in advance and may not be added at settlement without prior confirmation.\n2.3 Available balance is the balance usable for new operations under current account rules. Frozen balance is reserved for accepted orders or approved business and is temporarily unavailable for other operations. Expected profit, pending compensation, node quotas, and unposted allocations are not available balance. Balance displays must name the asset; quantities of different assets must not be summed directly.\n2.4 An AI sequence is the business record for one confirmed plan, linked from step 1 under the rules. Current step, order results, and eligibility evidence are maintained by the server. Normal disconnection or exiting the app does not terminate the sequence; reset means ending the old sequence under the conditions in this Agreement.\n2.5 Computing-node quota is a USDT-equivalent accounting unit accumulated from final eligible losses under the rules to generate nodes. A node is a qualification record for later entitlement distribution—not instant cash, credited PANTA, or a tradable, stakeable, or freely transferable on-chain NFT merely by name.\n2.6 A rules snapshot is the rules version, parameters, amounts, price basis, terms, and related evidence saved when an order or sequence is confirmed. A new version must not overwrite old snapshots. Server records are used to verify status, but users may submit other evidence for review; reasonable objections must not be barred solely because records are held by the platform.\n\nArticle 3: Eligibility and Agreement Confirmation\n\n3.1 The platform may provide features only to users within approved regions, age ranges, and suitability scopes. The production version should state identity-verification requirements, product availability, and reasons for limits. Wallet connection, UI visibility, or account balance alone do not establish eligibility for every product.\n3.2 Users must use accounts and assets they are authorized to control; impersonation, unauthorized use of others' accounts, forged eligibility materials, or manipulation of signals or outcome evidence is prohibited. When the platform needs further verification, it should state required materials and business purpose; limits on new participation and performance of existing orders should be explained separately.\n3.3 Before placing an order, users should be able to review principal, premium, any extra fees, prediction options, worst-case loss, settlement conditions, determination sources, and dispute paths. The platform should provide clear confirmation steps and must not replace genuine consent with default consent, hidden fees, automatic amount switching, or pressuring repeated actions.\n3.4 AI signals, historical results, sample returns, node-pool size, and others' entitlement records are not promises of future outcomes. Users may lose accepted-order principal and related premiums; node entitlements may be affected by pool balance, effective weight, price, and processing status. Users must not treat any example as a fixed personal return or a definite recovery timeline.\n\nArticle 4: Event Contract Prediction Rules\n\n4.1 Before starting an AI sequence, users should review available plans, position principal, estimated premium, total funding need, signal validity, the 60-second settlement rule, and the 90% compensation conditions. A new sequence may start only from step 1; the plan may not be switched mid-sequence; users may not combine skipped steps, amount changes, or parallel open orders into a new eligible sequence. After the user selects an event outcome and enters JOULE principal, the platform calculates premium from the approved position base: if principal is not more than 10% of the base, premium is 15% of principal; if more than 10%, premium is 20%; exactly 10% uses 15%.\n4.2 AI signals should show the underlying, direction, time, validity period, and an identifiable signal ID. When ordering, users must confirm a direction consistent with the then-valid signal. If the signal updates while waiting or reconnecting, re-verify; expired signals must not be reused from client cache. Using an AI signal does not mean the platform or algorithm knows future outcomes. Historical accuracy, demos, and explanations are not guarantees for this order. The platform must not replace actual principal, premium, and compensation conditions with phrases such as \"guaranteed win\", \"sure profit\", or \"no loss even if wrong\".\n4.3 Each event must separately list name, factual description, selectable outcomes, open and close times, time zone, participation limits, outcome criteria, primary and backup evidence sources, profit calculation, worst-case loss, cancellation or postponement rules, and appeal arrangements. Ambiguous events, events lacking determination standards, or events whose critical economic parameters are unapproved must not open for real orders. On acceptance, the platform must verify the event is still open, server time is before close, options and version are valid, user eligibility and limits are met, and balance is sufficient. Close timing is not based on device time or a client countdown still showing when the user clicked.\n4.4 After principal and premium are successfully frozen and the order is accepted, the platform returns acceptance time and the agreed settlement time, calculated as server acceptance time plus 60 seconds—not from when the user opened the page, received a signal, or clicked. Network delay does not shorten or extend the fixed determination basis. Sixty seconds is the agreed determination time and does not promise funds credit at the exact second the client countdown reaches zero. At that time, obtain result evidence from the agreed source; if evidence is missing, the source is abnormal, or results conflict, keep pending settlement and state the status—do not auto-mark as a loss.\n4.5 Only when a current valid sequence has clear rules shown and no open orders, and the user truly submits a direction inconsistent with the valid signal or an amount inconsistent with the current fixed step, does the reject-and-reset design apply. Show the specific reason, affected sequence, and next available action, and retain history. After reset, a new sequence may start from step 1; do not stitch old-sequence losing orders with new-sequence orders to count eight consecutive losses. Completed P&L of the old sequence remains and does not automatically receive 90% compensation, without prejudice to review for platform error, wrongful reset, or other disputes.\n4.6 A rejected non-compliant request itself does not fill and creates no new principal loss, premium, or loss node. Draft language about converting non-compliant losses to nodes is not yet an executable rule and must not invent loss or compensation for rejected orders.\n4.7 Pausing later steps is not eight consecutive losses; an incomplete sequence cannot claim 90% compensation proportional to losing legs. Active termination, long idle, and restore deadlines need formal rules; do not invent an undisclosed expiry. Normal exit or disconnection is not voluntary abandonment. For 90% JOULE compensation under the current design, the same sequence must simultaneously meet: each leg has insurance enabled with principal and premium actually frozen; each direction matches the valid AI signal at acceptance; each principal and step order matches the confirmed plan; and all eight legs fully settle as eligible losses. Compensation equals 90% of the sum of the eight eligible principals, paid in JOULE; premiums are not in that 90% base. Compensation must not be described as returning 90% of all outlays, and is not auto-converted to USDT, cash, or PANTA. Other asset exchanges need separate rules and authorization.\n4.8 Eligibility and successful payment are two stages. If eligible but funds are short, accounting is abnormal, or limits apply, keep the payable obligation and details, show processing or a clear hold reason, and handle under law and contract; do not rewrite payment difficulty as ineligibility.\n4.9 Compensation runs once against the sequence's unique record. If payment succeeds but the response is lost, later queries and retries return the original result without double payment. Payment failure remains truly unfinished; users must not be required to create a new sequence or reorder to \"activate\" the original compensation. If a pre-confirmed mechanism allows different rates per leg, keep per-leg snapshots and accumulate actual fees; do not reprice all history with one current rate. Rate-mechanism changes affecting confirmed sequences must state scope first and must not retroactively increase cost via a new page.\n4.10 Minimum units, precision, per-leg rounding, and residual handling must be fixed before release and kept consistent. Display rounding for readability must not change ledger details; example precision is not approved payment precision. Fees, spreads, and residuals must not be hidden by merged display.\n\nArticle 5: System Services\n\n5.1 Disconnection or timeout: the user first queries the original order; the platform returns accepted, clearly rejected, or still pending. Do not induce repeat payment while the result is unknown; only after confirmed non-acceptance may a new request be confirmed under current valid rules.\n5.2 Expired signal or quote: reject the old request, show the reason, and refresh content. Do not silently replace direction, amount, or fees, and do not treat expiry as an automatic AI violation reset. If the old request was already accepted, perform it under its snapshot.\n5.3 Abnormal result or price: pause affected determinations, valuations, or distributions; provide status, scope, and inquiry channels. Missing results must not be recorded as failure losses; abnormal valuations must not enlarge the loss base. Backup sources must follow pre-published order and exception rules.\n5.4 Accounting differences or unknown external status: verify original records and external receipts first; do not resend irreversible actions. After confirmed failure, unfreeze or retry under the rules; unknown is not refunded. Completed user fund actions and unfinished later buy/pool steps should be shown separately.\n5.5 Funding shortfall: stop new business that may widen the gap, keep formed obligations, disclose pending status, and handle under the approved plan. Do not forge credits, set available balance negative, or fill gaps with undisclosed extra charges.\n5.6 Risk limits: the platform may verify or restrict under formally approved and properly disclosed rules, but must distinguish limiting new orders, delaying payment, and cancelling eligibility. Limits must not auto-rewrite historical win/loss or already-met economic conditions; exceptions need facts and grounds, with a usable review channel.\n5.7 During maintenance, service stop, or product closure, historical orders, compensation, disputes, and auditable records still need handling. Inability to place new trades does not erase existing balances, payable compensation, or appeal rights. Turning off new business must not also shut down all historical query and performance flows.\n\nArticle 6: Disclaimers\n\nThe service does not compensate losses arising from:\n6.1 Failure to follow strategy: any departure from the platform's standard position-management rules\n6.2 Extreme market conditions: losses from exchange failure, liquidity dry-up, or market manipulation\n6.3 System and operational risk: losses from user device failure, operational error, or account theft\n6.4 Policy and compliance risk: trading interruption or prohibition due to changes in laws, regulations, or regulatory orders\n6.5 Inherent token risk: large decline or collapse in JOULE market value affecting its use as margin and settlement currency\n6.6 Fraud and misconduct: fraud, money laundering, market manipulation, or other illegal activity by the user\n6.7 Force majeure: platform system failure caused by force majeure\n\nArticle 7: Risk Disclosure\n\nThe user confirms full understanding and acceptance of the following risks:\n7.1 No principal or profit guarantee: this Plan compensates only part of losses and absolutely does not guarantee principal safety or profit\n7.2 Strategy-dependence risk: protection effect depends entirely on strict adherence to strategy\n7.3 Liquidity and lock-up risk: compensation entering wealth-management accounts may involve investment risk and lock-ups affecting liquidity\n7.4 Third-party risk: relied-upon exchanges carry operational, security, and value-volatility risks\n7.5 Regulatory uncertainty: the platform faces global regulatory uncertainty and possible suspension\n7.6 Technology and security risk: including asset loss from smart-contract vulnerabilities, hacks, and similar events\n\nArticle 8: Amendment, Termination, and Disputes\n\n8.1 Amendment: the platform may revise this Agreement for legal or operational needs; material changes will be announced on the platform\n8.2 Termination: users may turn off the protection switch at any time; the platform may terminate for breach; the Plan may also end for legal or policy reasons\n8.3 Disputes: disputes under this Agreement should first be resolved amicably; failing that, they will be submitted to the designated arbitration institution or court\n\n[FINAL CONFIRMATION] You understand and agree that enabling the Insurance Switch is the sole and final way you confirm you are bound by this entire Agreement. Decide based on your independent judgment."
  },
  walletBind: {
    connectWallet: "Connect",
    inputPlaceholder: "Enter address",
    bind: "Bind",
    binding: "Binding",
    tip: "Tip: If wallet connection fails, you can try manually entering the wallet address to bind"
  },
  loginModal: {
    openWalletApp: "Open {wallet}",
    openWalletConnect: "Open {wallet} to connect",
    openWalletSign: "Open {wallet} to sign",
    returnToBrowser: "Return here when finished",
    loginStepLabel: "Step {step}/2",
    stepConnectTitle: "Connect wallet",
    stepConnectHint: "Approve the connection in your wallet, then return here",
    stepConnectHintWithOpen: "Tap below to open your wallet and approve the connection, then return here",
    stepSignTitle: "Sign in",
    stepSignHint: "Sign the login message in your wallet (no funds move), then return here",
    stepSignHintWithOpen: "One more step: tap below to open your wallet and sign the login message",
    title: "Login to PANTA MARKET",
    connectWallet: "Connect",
    connecting: "Connecting...",
    alreadyConnected: "Connected",
    demoLogin: "Demo Login (Mock)",
    tip: "Tip: If wallet connection fails, you can try manually entering the wallet address to bind",
    inputLabel: "Enter wallet address",
    inputPlaceholder: "0x234d456f6798...",
    bind: "Bind",
    binding: "Binding",
    bindSuccess: "Bind successful",
    bindSuccessHint: "Bind successful, please login again",
    bindFailed: "Bind failed",
    noAuthCode: "Authorization code missing",
    invalidAddress: "Invalid wallet address format",
    confirmTitle: "Confirm Binding",
    confirmWarning: "Please carefully confirm that the following address is your wallet address. It cannot be changed after binding",
    addressLabel: "Wallet Address",
    cancel: "Cancel",
    confirm: "Confirm Bind",
    loginSuccess: "Login successful",
    connectFailed: "Connection incomplete, please retry",
    waitingWalletReturn: "Waiting for wallet",
    waitingWalletHint: "Confirm in your wallet, then return to this page",
    waitingWalletHintShort: "If it did not open, tap below to open your wallet",
    retryLogin: "Retry login",
    networkRequired: "Switch network",
    networkRequiredHint: "Switch to {chain}, then return here and retry",
    switchingNetwork: "Confirm network switch",
    switchingNetworkHint: "Approve switching to {chain} in your wallet",
    signatureRequired: "Sign to log in",
    signatureHint: "Sign in your wallet — this does not transfer funds",
    verifyingLogin: "Verifying",
    verifyingHint: "Please wait"
  },
  walletProfile: {
    title: "Profile",
    address: "Address",
    accountName: "Account Name",
    inviteCode: "Invite Code",
    deactivateAccount: "Deactivate Account",
    logout: "Logout",
    switchAccount: "Switch Account",
    confirmLogout: "Are you sure you want to logout?",
    loggingOut: "Logging out...",
    confirmSwitch: "Are you sure you want to switch account? Current account will be logged out",
    developing: "Under Development",
    addressCopied: "Address Copied",
    inviteCodeCopied: "Invite Code Copied"
  },
  aiPrediction: {
    stakeAutofill: "AI Assist",
    stakeAutofillWarning: "For assistance only. Suggested amounts may be wrong; check before ordering. Auto-fill pauses when latency exceeds 800ms or the connection check fails or expires, and resumes on recovery. Manual orders are unaffected.",
    stakeAutofillUnavailable: "Connection unstable or over 800ms. Cannot enable yet.",
    stakeAutofillPaused: "Auto-fill paused: connection unstable. Enter an amount manually.",
    insuranceSyncing: "Syncing insurance step…",
    predictionBuffer: 'Preparing next prediction',
    scheduleResultPending: 'Round result unavailable, retrying',
    recovery: {
      checking: 'Checking your previous prediction. No duplicate charge.',
      pending: 'Your previous prediction is still processing. Checking automatically.',
      unknown: 'Result not yet confirmed. Reconnect or tap to check again.',
      released: 'Previous prediction was cancelled or not generated. Reservation released.',
      recovered: 'Prediction recovered. No duplicate charge; original entry deadline applies.',
      expired: 'Prediction was generated and counted, but its entry window has expired.',
      available: 'Self prediction found. Waiting for clock sync or the current operation to finish.',
      bullish: 'Direction: rise', bearish: 'Direction: fall',
    },
    tierSelection: "AI insurance tier",
    tierSaving: "Confirming tier. Please wait.",
    tierUnknown: "Tier result unknown. Tap to check and retry.",
    tierPending: "Selected tier pending server confirmation",
    ordinaryPreviewHint: "This amount will be previewed for ordinary insurance with confirmation.",
    title: "AI Prediction",
    bookingTitle: "AI Session Booking",
    bookingExpand: "Expand",
    bookingCollapse: "Collapse",
    bookingNextSystem: "Next session · SGT",
    bookingNextMine: "My next reservation",
    bookingNone: "None",
    bookingStartingSoon: "Your booked session is starting soon",
    bookingToday: "Today",
    bookingTomorrow: "Tomorrow",
    bookingTimezone: "SGT",
    bookingQuota: "Sessions remaining: {remaining}/{dailyLimit}",
    bookingSeats: "{occupied}/{capacity} seats",
    bookingEmpty: "No available sessions",
    bookingWaiting: "You will join automatically when your current operation finishes",
    bookingEnded: "Ended",
    bookingJoin: "Join session",
    bookingReserve: "Reserve",
    bookingJoined: "Joined",
    bookingReserved: "Reserved",
    bookingFull: "Full",
    bookingConfirm: "Confirm reservation",
    bookingWarning: "A successful reservation uses 1 session for that day. It still counts if you do not attend.",
    bookingQuotaExhausted: "You have used all sessions available for this day",
    bookingUnavailable: "Reservation is unavailable",
    bookingFailed: "Reservation failed. Refresh and try again.",
    eventContract: "Event Contract",
    nextRound: "Next Round",
    aiPool: "AI Pool",
    orderWindowLabel: "Time left to order",
    stakeFromStrategy: "Stake set by strategy",
    stakeTier: "Tier {tier}",
    stakeStep: "Step {step}",
    tierMatched: "Matched tier {tier} · step {step}/{total}",
    tierBound: "Current tier {tier} · step {step}/{total}, this step requires {amount} JOULE",
    tierBoundNoStake: "Current tier {tier} · step {step}/{total}",
    amountNotAi: "Amount does not meet AI insurance requirements",
    amountInvalid: "Enter at least 0.1 JOULE, up to 18 decimal places",
    tierAmbiguous: "Insurance tiers are ambiguous and cannot be opened",
    premiumEstimateAmount: "Est. premium {premium} JOULE",
    ordinaryInsuranceTitle: "This order uses event insurance",
    ordinaryInsuranceBody: "This order is event insurance, not an AI-round payout. Premium follows the preview after you confirm.",
    sessionConflict: "An AI insurance round is still active. Restore or end it before placing event insurance.",
    conversionTitle: "Convert to ordinary insurance?",
    conversionDesc: "This order will switch to ordinary insurance and end this AI insurance round. Prior AI loss streaks will not be paid. Ordinary premium {premium} JOULE.",
    conversionConfirm: "Confirm conversion",
    orderSuccess: "AI prediction order placed successfully!",
    orderFailed: "AI prediction order failed",
    orderConfirming: "Confirming AI prediction order result, please do not submit again",
    orderNotFilled: "AI prediction order was not filled; no funds were deducted",
    recoverTitle: "Confirm pending AI prediction order",
    recoverContent: "An unconfirmed AI prediction order was found ({symbol} {direction} {amount}). The original idempotency key will be confirmed without placing a duplicate order.",
    recoverConfirm: "Confirm order",
    recoverCancel: "Cancel",
    predictionResult: "AI Prediction Result",
    countdown: "Countdown",
    expectedProfit: "Expected Profit",
    active: "Active",
    aiAnalysis: "AI Smart Rise/Fall Probability Analysis",
    updateTime: "Update Time",
    probabilityUp: "Bullish Probability",
    probabilityDown: "Bearish Probability",
    startPrediction: "Start Prediction",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "Follow this round",
    scheduleBinding: "Binding signal...",
    ruleScore: "Rule score {score}, not a win probability",
    selectTier: "Select an insurance tier",
    scheduleUnscheduled: "Not scheduled",
    scheduleWaiting: "Waiting for next slot",
    schedulePreparing: "Round {round} preparing",
    scheduleUnavailable: "Cannot place order",
    scheduleFinished: "Round ended",
    predicting: "Predicting...",
    stayOnPageHint: "Stay on this page. Leaving may lose the prediction result.",
    waitingResult: "Waiting",
    userInfo: "User Info",
    predictCount: "Prediction Count",
    freeCount: "Free Predictions",
    openTime: "Open at: {time1}",
    up: "Up",
    down: "Down",
    rise: "Long",
    fall: "Short",
    notConnected: "Not Connected",
    count: "Count",
    learnMore: "Learn More",
    calculating: "Calculating...",
    settled: "Settled",
    settling: "Settling",
    syncingTime: "Syncing time",
    settledAt: "Settled at",
    refunded: "Refunded",
    won: "Won",
    lost: "Lost",
    position: {
      calculating: "Calculating...",
      settled: "Settled",
      settling: "Settling",
      syncingTime: "Syncing time"
    },
    loginFirst: "Please login first",
    sessionSyncing: "Syncing",
    openPrice: "Open Price",
    closePrice: "Close Price",
    profitLoss: "P&L",
    actions: {
      rise: "Long",
      fall: "Short"
    },
    holdings: {
      current: "Positions",
      history: "History",
      aiHistory: "AI History",
      empty: "No positions",
      historyEmpty: "No history",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "Buy AI Prediction Privilege",
      description: "Pay {amount}{symbol} to get {times} extra AI prediction times.",
      upgradeAmount: "Upgrade Amount",
      balance: "Available Balance",
      cancel: "Cancel Purchase",
      confirm: "Confirm Purchase",
      purchasing: "Purchasing...",
      purchaseSuccess: "Purchase Successful",
      purchaseFailed: "Purchase Failed",
      dailyLimit: "You can purchase up to once per day."
    },
    noPredictionAlert: {
      title: "AI Prediction Failed",
      description: "Your AI prediction count is 0. You cannot use AI prediction at this time. Please purchase to continue.",
      cancel: "Cancel Purchase",
      confirm: "Confirm Purchase"
    },
    toasts: {
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      insuranceTierUnavailable: "Select an insurance tier first",
      amountTierMismatch: "Amount does not match an insurance tier",
      bindStakeChanged: "Server stake differs from the input. The original order was stopped",
      predictionFailed: "Prediction failed",
      predictionSuccess: "Prediction completed",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again",
      resumeFailed: "Failed to resume prediction; try again later",
      onlyBtcUsdt1m: "AI prediction only supports BTC, crude oil, and gold in 1-minute mode",
      entryWindowExpired: "Entry window expired; start AI prediction again",
      scheduleRoundRequired: "Sync the current round first",
      scheduleNotReady: "Result is not ready yet",
      scheduleExpired: "This round has ended. Wait for the next one",
      scheduleUnavailable: "Scheduled prediction is unavailable",
      unsettledConflict: "An open position is still settling",
      orderWindowExpired: "Order window ended; start AI prediction again"
    },
    previousOrder: {
      title: "Previous order",
      won: "Won",
      lost: "Lost",
      refunded: "Refunded",
      pending: "Pending settlement",
      review: "Under review"
    },
    analyzing: "Analyzing...",
    insurance: "Insurance",
    insuranceOn: "Active",
    insuranceOff: "Inactive",
    aiLabel: "AI",
    lookLong: "Bullish",
    lookShort: "Bearish",
    selfQuotaRemaining: "Self-prediction remaining: {remaining}/{limit}",
    followRoundProgress: "AI Follow · Round {current}/{total}",
    followRoundsCompleted: "AI Follow completed · {current}/{total}",
    selfQuotaLoadingShort: "Loading quota…",
    selfQuotaLoginHint: "Log in to view quota",
    selfQuotaLoading: "Quota loading, try again later",
    selfQuotaExhausted: "Free self-prediction quota used up today; paid prediction not open yet"
  },
  positionModal: {
    title: "Price Prediction",
    insurance: "Insurance",
    long: "Long",
    short: "Short",
    balance: "Balance",
    available: "Available",
    loading: "Loading...",
    confirm: "Confirm",
    processing: "Processing order...",
    success: "Order placed successfully!",
    insuranceOn: "Enabled",
    insuranceOff: "Disabled",
    aiLabel: "AI",
    lookLong: "Bullish",
    lookShort: "Bearish",
    operationFailed: "Operation failed",
    balanceFetchFailed: "Failed to fetch balance",
    minAmount: "Minimum amount is 0.1 JOULE",
    insufficientBalance: "Insufficient balance, current balance: {balance} JOULE",
    createFailed: "Failed to create position",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "New chat",
    manual: "Manual",
    manualCardTitle: "Open operation manual",
    manualCardDesc: "Illustrated steps for deposit, exchange, transfer, and AI prediction",
    hello: "Hi, I am your AI assistant",
    hint: "Ask about markets, where to find event/AI insurance rules, team details, invite links, or risk tips.",
    placeholder: "Ask something...",
    send: "Send",
    thinking: "Analyzing...",
    disclaimer: "For reference only — not investment advice.",
    bullish: "Bullish",
    bearish: "Bearish",
    aiAnalysis: "AI summary",
    strategy: "Trading strategy",
    reasoning: "Reasoning",
    targetPrice: "Target {price}",
    stopLoss: "Stop {price}",
    takeProfit: "Take profit {price}",
    dirLong: "Long",
    dirShort: "Short",
    dirNeutral: "Neutral",
    analysisDone: "Finished analysis for {symbol} ({timeframe}). See the card below.",
    analysisBtc: "Here is a BTC short-term analysis.",
    analysisEth: "Here is an ETH range analysis.",
    analysisRisk: "Here is a market-risk readout.",
    suggestions: {
      btc1m: "Analyze BTCUSDT 1m short-term outlook",
      ethTrend: "Should I chase ETH or wait?",
      marketRisk: "What is the current market risk appetite?",
      eventRules: "Where do I view event-contract insurance rules?",
      aiRules: "How do AI prediction tiers/rules work?",
      teamWhere: "Where can I see team details?",
      inviteWhere: "Where is the invite link / bind superior?"
    },
    guides: {
      eventRules: "Event-contract insurance rules: open Event Contract trading, tap the rules entry next to the insurance switch. Use Preview for premiums, limits, payout/pool highlights, and Full Agreement for the legal text.",
      aiRules: "AI Prediction: open the center tab → AI Prediction. Check next-round countdown, insurance tier/step, and self-prediction quota. Rules are in the same insurance sheet (AI preview + full agreement). Orders must match tier size and direction.",
      teamWhere: "Team details: sidebar or Me → My Team. Switch trade/finance earnings, then Team details for referrals, volume, level, and members. Tap a member to drill into their directs.",
      inviteWhere: "Invite & bind: sidebar/Me → Invite friends to copy your share link (?ref=). If unbound, a Bind superior modal appears after login; you can also bind on the invite page. With no invite param, the field prefills the default superior address."
    },
    generic: {
      a: "Got it. Ask about markets, event/AI rule locations, team/invite entry points, or tap a quick prompt below.",
      b: "OK. Outlook cards plus pointers to platform features.",
      c: "Try quick prompts like event rules, AI rules, team details, or invite link."
    }
  },
  operationManual: {
    title: "Operation Manual",
    docTitle: "PANTA MARKET Operation Manual",
    sourceHint: "Illustrated steps adapted from the official manual. Tap screenshots to zoom."
  },
  pantaMarket: {
    comingSoon: 'Coming soon',
    title: "Panta Market",
    tokenSection: "PANTA Governance Token",
    todayBurn: "Burned Today",
    totalBurn: "Total Burned",
    burned: "Burned",
    initialSupply: "Initial Supply",
    maxSupply: "Max Supply",
    finalCirculation: "Final Circulation",
    contractAddress: "Contract: ",
    copied: "Copied",
    ecoSection: "PANTA · AI Ecosystem",
    ecoTabs: {
      market: "Market Analysis",
      arbitrage: "Arbitrage Tools",
      acquisition: "Global Acquisition",
      video: "Video Creation"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · Creative Groups",
    groupTabs: {
      recommend: "For You",
      hot: "Hot",
      ipDrama: "IP Drama",
      ipCollab: "IP Collab",
      data: "Data"
    },
    filters: {
      all: "All",
      new: "New Releases",
      ending: "Ending Soon",
      highScore: "Top AI Score"
    },
    project: {
      badge: "Planet Premiere",
      title: "《Panta AI · Rise》 AI Animated Short",
      score: "AI Score 92",
      tagDrama: "IP Drama",
      tagRights: "Rights #0001",
      desc: "Panta AI turns the tide with me — an AI app tutorial short drama"
    },
    values: {
      todayBurn: "321",
      totalBurn: "4,212",
      initialSupply: "10M",
      maxSupply: "210M",
      finalCirculation: "21M"
    }
  },
  copyTrade: {
    menuTitle: "Copy Trade",
    pageTitle: "Copy Trade",
    fallback: "Operation failed. Please try again later.",
    pauseRule:
      "If you are still paused when this week's settlement completes, the copy relationship will be cancelled automatically next week.",
    pauseSuccess: "Paused successfully",
    resumeSuccess: "Resumed",
    endSuccess: "Ended",
    followSuccess: "Copy started",
    pendingReviewToast: "Pending trader review",
    savedSuccess: "Saved",
    registerSuccess: "Registered. Deposit frozen.",
    cancelRequested: "Cancellation requested",
    cancelWithdrawn: "Cancellation withdrawn",
    kickedSuccess: "Removed",
    approvedSuccess: "Approved",
    rejectedSuccess: "Rejected",
    filledToForm: "Filled into the follow form",
    traderNotFound: {
      search: "This address is not a trader",
      business: "This trader is currently unavailable",
    },
    tabs: {
      board: "Leaderboard",
      follows: "My follows",
      join: "Follow",
      trader: "Lead",
      apps: "Apps",
      fans: "Followers",
      rules: "Rules",
      settings: "Rules",
      follow: "Follow",
    },
    ui: {
      refresh: "Refresh",
      search: "Search",
      loginWallet: "Connect wallet",
      needLoginAction: "This action requires wallet login, same as placing orders.",
      needLoginTrader: "Trader APIs require login.",
      loginToView: "Log in to view",
      loading: "Loading…",
      empty: "None",
      readonly: "read-only",
      yes: "Yes",
      no: "No",
      immediate: "effective immediately",
      current: "Current",
      nextWeek: "Next week",
      pause: "Pause",
      resume: "Resume",
      end: "End",
      save: "Save",
      kick: "Remove",
      approve: "Approve",
      reject: "Reject",
      requestCancel: "Request cancellation",
      withdrawCancel: "Withdraw cancellation",
      confirmFollow: "Confirm follow",
      registerWithDeposit: "Freeze deposit & register",
      registerConfirmTitle: "Confirm registration",
      registerFreezeConfirm: "{amount} JOULE margin will be frozen in the trading account.",
      platformSettings: "Platform settings",
      settingsTip:
        "Only ordinary insured orders are copied. Uninsured ordinary orders and AI orders are not copied, and generated COPY orders do not lead further copies. Traders use the existing order API and must not pass orderSource. Followers see COPY orders in the order list. Amounts show 2 decimals; extra digits are truncated.",
      deposit: "Deposit",
      depositFreezeWeeks: "Deposit freeze weeks",
      maxFollowers: "Follower cap",
      shareRateRange: "Share rate range",
      shareRateDefault: "Default share rate",
      shareRateNextWeek: "Share rate applies next week",
      pendingShareHint: "Effective next Monday: {rate}",
      pendingMaxFollowersHint: "Effective next Monday: {n}",
      depositFrozenShort: "Still frozen",
      minFollowStake: "Min follow stake",
      ratioRange: "Ratio range",
      maxSimultaneousFollows: "Max simultaneous follows",
      defaultReview: "Default review",
      defaultMinBalance: "Default balance threshold",
      settlementTimezone: "Settlement timezone",
      leaderboardMeta: "Leaderboard min / size",
      leaderboardMetaValue: "{min} orders / {size} rows",
      weekLeaderboard: "This week's win-rate board",
      expertLeaderboard: "Trader leaderboard",
      heroTitle: "Become a lead trader",
      heroDesc: "Start leading trades and earn profit share",
      heroActiveTitle: "You are a lead trader",
      heroActiveDesc: "Your lead-trader status is active",
      heroRegister: "Register",
      heroSettings: "Lead settings",
      myLeading: "My leading",
      winRateBoard: "Win rate",
      pnlBoard: "Profit",
      searchAddress: "Search address",
      searchNicknameOrAddress: "Search nickname or address",
      searchQueryTooShort: "Enter at least 2 characters",
      winRateShort: "Win rate",
      followersLabel: "Followers:",
      shareRateLabel: "Share rate:",
      roundPnlLabel: "Round PnL:",
      settledOrders: "{n} settled",
      activeCount: "Active",
      followStatsShort: "Pool {pool} · Held {cash}",
      traderSettings: "Lead settings",
      confirmChanges: "Confirm changes",
      confirmCancel: "Confirm cancellation",
      cancelModalTitle: "Cancellation notice",
      activeInProgress: "In progress",
      leadingFollowerCount: "Followers {n}",
      auditApps: "Applications {n}",
      leaderboardNote:
        "Counts this week's settled win/loss ordinary insured orders only, after the minimum order count. Not all-time and not AI win rate. Team name and cumulative follow volume are not provided.",
      weekStart: "Week start (Mon): {date}",
      leaderboardEmpty: "No listed traders yet. Search by full address to follow.",
      winRate: "Win {n}%",
      boardSub:
        "Share {share} · Followers {followers}/{max} · Settled {orders} · Week PnL {pnl} JOULE",
      searchTrader: "Search trader",
      walletPlaceholder: "Full wallet address 0x…",
      address: "Address",
      status: "Status",
      shareRate: "Share rate",
      review: "Review",
      minBalance: "Balance threshold",
      followerCount: "Followers",
      startFollow: "Start following",
      traderWallet: "Trader address",
      followMode: "Follow mode",
      ratioLabel: "Ratio (%), range {min} ~ {max}",
      insuranceMode: "Insurance mode",
      takeProfit: "Take profit (JOULE, optional)",
      stopLoss: "Stop loss (JOULE, optional)",
      takeProfitPh: "Pause when weekly net PnL reaches this",
      stopLossPh: "Pause when weekly net loss reaches this",
      followHint:
        "You may follow up to {n} trader(s) at the same time. When the limit is reached, starting a new follow will terminate the existing relationship first; this takes effect immediately and is not a preview. Follow parameters cannot be changed individually—end the current relationship and follow again to adjust them.",
      endConfirm:
        "End the copy-trading relationship with this trader? You will stop following their signals. Historical orders and settled PnL are unaffected.",
      weeklyPoolHint:
        "The pool is this week's pool, not cumulative follow volume. Ended relationships and pending applications are not in this list.",
      networkUnclear:
        "Result unconfirmed. Refresh and check the current relationship or trader profile before retrying.",
      myFollows: "My follows",
      noFollows: "No follow relationships",
      followSub:
        "{mode}{ratio} · {insurance} · Locked share {share}",
      followStats:
        "Week PnL {pnl} · Pool {pool} · Held {cash}",
      pauseReason: "Pause reason: {reason}",
      registerTrader: "Register as trader",
      registerHint:
        "Registration: pay {amount} JOULE as a lead-trader deposit (frozen while active; refunded after cancel review). One trader identity per wallet.",
      registerBalanceHint:
        "After freezing {deposit} JOULE deposit, available balance must still be ≥ {remain} JOULE.",
      shareRateInput:
        "Share rate (%) range {min} ~ {max}; changes apply next cycle.",
      maxFollowersInput: "Follower limit (≤ {max})",
      reviewMode: "Approval method",
      minBalanceInput: "Follower balance threshold · optional (JOULE)",
      myTrader: "My trader profile",
      depositHeld: "{amount} / frozen {held}",
      currentFollowers: "Current followers",
      cancelEffective: "Cancel effective at",
      depositRelease: "Deposit release at",
      editParams: "Edit settings",
      editHint:
        "Share rate / cap apply next week; review and threshold apply immediately. The settlement lock is Sun 22:00 until before Mon 01:00 (SGT). Trust the server; do not resume edits at Mon 00:00 on your own.",
      shareRatePercent: "Share rate (%)",
      minBalanceJoule: "Balance threshold (JOULE)",
      cancelTip:
        "After cancellation you still lead this week; identity ends next Monday 00:00; deposit stays frozen one more week then returns. You can withdraw before it takes effect.",
      followers: "Followers",
      followerSub: "{mode}{ratio} · Week PnL {pnl} · Held {cash}",
      applications: "Pending applications",
      noApplications: "No applications",
      fillForm: "Fill follow form",
      needTraderFirst: "Register as a trader first",
      cancelRequestedAt: "Cancel requested at",
      ratioRangeInvalid: "Ratio must be between {min} and {max}",
      shareRangeInvalid: "Share rate must be between {min} and {max}",
      maxFollowersInvalid: "Follower cap cannot exceed {max}",
      needShareRate: "Enter a share rate",
      needMaxFollowers: "Enter a follower cap",
      needRatio: "Enter a ratio",
      badTakeProfit: "Invalid take-profit amount",
      badStopLoss: "Invalid stop-loss amount",
      badMinBalance: "Invalid balance threshold",
      insuranceShortFollow: "Follow",
      insuranceShortOn: "Always on",
      insuranceShortOff: "Always off",
      symbolSettings: "Copy symbol settings",
      symbolPickHint: "all off by default; turn on manually, editable anytime",
      followSymbolHint: "Choose from symbols this trader allows. Turn on at least one.",
      followSymbolWait: "Search a trader first, then pick symbols to follow.",
      symbolNeedOne: "Turn on at least one symbol",
      symbolNotAllowed: "A selected symbol is not allowed by this trader",
      effectiveSymbols: "Effective",
      editSymbols: "Edit symbols",
      allowedSymbols: "Open symbols",
      weekPnlLabel: "Week PnL:",
      currentNetPnlLabel: "Current Net PnL",
      categoryCrypto: "Crypto",
      categoryCommodity: "Commodities",
      categoryEquity: "Equities",
      symbolListCol: "List",
      symbolLeadCol: "Lead",
      symbolFollowCol: "Follow",
      symbolTags: "Open",
      leadingSymbols: "Leading symbols",
      detail: "Details",
      enabled: "On",
      disabled: "Off",
      held: "Open",
      notHeld: "Flat",
      weekSettledOrders: "Week settled",
      historicalNetPnl: "All-time PnL",
      copyTotalPnl: "Copy total PnL",
      historicalSharePayout: "Share payouts",
      allOrders: "All",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "Open",
      settledOrdersTab: "Settled",
      colInterval: "Duration",
      colOrderTime: "Order time",
      colSelfPnl: "Own PnL (incl. premium)",
      colEstShare: "Est. share (JOULE)",
      traderOrdersTitle: "{symbol} lead orders",
      followOrdersTitle: "{symbol} copy orders",
      selfPnl: "Own PnL",
      estimatedShare: "Est. share",
      inProgress: "In progress",
      followAssets: "PnL by asset",
      byAsset: "By asset",
      followHistory: "Ended",
      followStartTime: "Start: ",
      followEndTime: "End: ",
      myPendingApps: "Pending",
      cashHeldHint: "Est. share hold this week {cash} JOULE",
      cashHeldFrozen: "Est. share deduction this round: {cash} (JOULE, frozen)",
      followedTrader: "Trader",
      followInfo: "Follow info",
      totalPnlJoule: "Total PnL (JOULE)",
      colTrader: "Trader",
      colPrincipal: "Stake",
      colPnlShare: "PnL (incl. premium) / share (JOULE)",
      traderInfo: "Trader profile",
      traderNotFound: "This address is not a trader",
      followSettingsRelationHint:
        "Follow mode, insurance, and TP/SL apply to the whole relation for all selected symbols. You can change them anytime in Follow settings.",
      followSettingsPrepareHint:
        "Confirm to use this config for all symbols you enable on this trader.",
      followOptions: "Follow options",
      noFollowOptions: "No follow options~",
      symbolFollowing: "Following",
      symbolPaused: "Paused",
      symbolIdle: "Not following",
      cancelFollowSymbol: "Unfollow",
      cancelSymbolConfirm: "Stop following {symbol}?",
      cancelLastSymbolConfirm: "This is the last symbol. Unfollowing will end the whole relation. Continue?",
      followNow: "Follow now",
      followAll: "Follow",
      unfollowAll: "Unfollow all",
      unfollowAllConfirm:
        "Stop following all symbols from this trader? This will end the entire copy relationship.",
      followSettings: "Follow settings",
      goFollowSettings: "Open ›",
      copyAccountBalance: "Copy account: {amount} JOULE",
      orderFollowerCount: "Followers",
      copyingStatus: "Copying",
      roleStatusLeading: "Leading",
      roleStatusFollowing: "Copying",
      roleStatusPaused: "Copy paused",
      copyOrderTag: "Copy",
      copyOpenPositions: "Open copy positions",
      copyInsuredOrdinary: "Ordinary insurance on",
      copyUninsured: "Uninsured",
      addSymbolHint: "This symbol will be added to your current follow.",
      myRelationStatus: "My follow",
      latestSettlements: "Latest settlements",
      resumeRelationFirst: "Relation is fully paused. Resume it in My Follows before per-symbol actions.",
      resumeStopLossHint:
        "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint:
        "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "Type",
      colPnlJoule: "PnL (JOULE)",
      tpSl: "Take profit / stop loss",
      takeProfitPhFull: "Pause after weekly net profit reaches — optional (JOULE)",
      stopLossPhFull: "Pause after weekly net loss reaches — optional (JOULE)",
      confirmModify: "Confirm",
      clearSearch: "Back to board",
      searchResultHint: "Search results (tap to open trader profile)",
      searchEmpty: "This address is not a trader",
      noMoreSettlements: "No more",
    },
    errors: {
      AUTH_REQUIRED: "Please connect your wallet first",
      AUTH_UNAVAILABLE: "Login service is temporarily unavailable. Please try again later.",
      POSTGRES_REQUIRED: "Service temporarily unavailable. Please try again later.",
      USER_NOT_FOUND: "User not found. Please log in again and retry.",
      INVALID_WALLET: "Please enter a complete wallet address",
      INVALID_QUERY: "Invalid search query; enter at least 2 characters",
      INVALID_AMOUNT: "Invalid amount format",
      INVALID_PARAM: "Invalid parameters. Please check and retry.",
      INVALID_FOLLOW: "You cannot copy your own trades",
      TRADER_EXISTS: "This wallet is already a trader. No need to register again.",
      TRADER_FULL: "This trader has reached the follower limit",
      TRADER_CANCELLED: "This trader account has been cancelled",
      TRADER_REGISTER_FAILED: "Failed to register as a trader. Please try again later.",
      TRADER_SETTINGS_FAILED: "Failed to save trader settings. Please try again later.",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "Insufficient available balance to freeze the deposit",
      BALANCE_TOO_LOW:
        "Copy-trade account balance is below this trader's threshold. Transfer JOULE from the trading account first",
      COPY_BALANCE_ZERO:
        "Copy-trade account balance is 0. Transfer JOULE from the trading account first",
      INSUFFICIENT_FUNDS: "Trading account balance is insufficient for transfer in",
      COPY_TRADE_BALANCE_INSUFFICIENT:
        "Copy-trade available balance is insufficient (frozen stake/share cannot be withdrawn)",
      ACCOUNT_NOT_FOUND: "Account error. Please try again later.",
      ACCOUNT_CONFLICT: "Account is being updated. Please try again later.",
      FOLLOW_EXISTS: "You are already following this trader",
      FOLLOW_LIMIT:
        "You already have an active copy relationship. End it before following another trader.",
      FOLLOW_FAILED: "Failed to start copying. Please try again later.",
      FOLLOW_NOT_FOUND: "Follow relation not found or not yours",
      PAUSE_FAILED: "Failed to pause copying. Please try again later.",
      RESUME_FAILED: "Failed to resume copying. Please try again later.",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "Failed to end copying. Please try again later.",
      APPLICATION_NOT_FOUND: "Pending application not found or not yours",
      APPROVE_FAILED: "Failed to approve the application. Please try again later.",
      REJECT_FAILED: "Failed to reject the application. Please try again later.",
      KICK_FAILED: "Failed to remove the follower. Please try again later.",
      SETTLEMENT_WINDOW: "Trader settings cannot be changed during the settlement window",
      CANCEL_FAILED: "Failed to request cancellation. Please try again later.",
      CANCEL_NOT_PENDING: "There is no cancellation request to withdraw",
      CANCEL_WITHDRAW_FAILED: "Failed to withdraw cancellation. Please try again later.",
      COPY_SETTINGS_MISSING: "Copy-trade settings are not ready. Please try again later.",
      INVALID_SYMBOL: "Select at least one supported symbol",
      SYMBOL_NOT_ALLOWED: "Includes a symbol this trader does not allow",
      TRADER_BALANCE_TOO_LOW: "Available balance after deposit freeze is too low to register",
      TIMEOUT: "Operation failed. Please try again later.",
      NETWORK: "Operation failed. Please try again later.",
    },
    status: {
      ACTIVE: "Active",
      PAUSED: "Paused",
      ENDED: "Ended",
      PENDING_REVIEW: "Pending trader review",
      CANCEL_PENDING: "Cancellation pending",
      CANCELLED: "Cancelled",
    },
    traderStatus: {
      ACTIVE: "Leading",
      CANCEL_PENDING: "Exiting",
      CANCELLED: "Cancelled",
    },
    pauseReason: {
      USER: "Paused by user",
      INSUFFICIENT_BALANCE: "Paused: copy-trade account balance too low",
      TAKE_PROFIT: "Take-profit triggered",
      STOP_LOSS: "Stop-loss triggered",
      TRADER_KICK: "Removed by trader",
      SWITCH: "Switched trader",
      SETTLEMENT_CLEANUP: "Removed at weekly settlement",
      TRADER_CANCEL: "Trader cancelled",
    },
    followMode: {
      EQUAL: "Equal amount",
      RATIO: "Ratio",
    },
    insuranceMode: {
      FOLLOW: "Follow trader",
      ALWAYS_ON: "Always on",
      ALWAYS_OFF: "Always off",
    },
    reviewMode: {
      AUTO: "Auto follow",
      MANUAL: "Review follow",
    },
    applicationStatus: {
      PENDING: "Pending",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      CANCELLED: "Cancelled",
      PENDING_REVIEW: "Pending",
    },
  },
}
